import { lazy, Suspense, type ComponentProps } from "react";
import { cn } from "~/lib/utils";

// Lexical is ~100 kB gzipped; load it only on pages that mount an editor.
const RichTextEditorLexical = lazy(
  () => import("~/molecules/RichTextEditorLexical"),
);

export function RichTextEditor(
  props: ComponentProps<typeof RichTextEditorLexical>,
) {
  return (
    <Suspense
      fallback={
        <div
          className={cn(
            "border-border bg-input/70 dark:bg-input/30 min-h-16 w-full rounded-lg border",
            props.className,
          )}
        />
      }
    >
      <RichTextEditorLexical {...props} />
    </Suspense>
  );
}
